import { render, staticRenderFns } from "./AuthTemplate.vue?vue&type=template&id=6a07a2b4&scoped=true&"
import script from "./AuthTemplate.vue?vue&type=script&lang=js&"
export * from "./AuthTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AuthTemplate.vue?vue&type=style&index=0&id=6a07a2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a07a2b4",
  null
  
)

export default component.exports